import { useState } from "react";
import { Facebook, Twitter, MessageCircle, Send, Linkedin, Mail, Link2, Check } from "lucide-react";
import { toast } from "sonner";

export const shareLinks = (title, url) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  return [
    { id: "whatsapp", label: "WhatsApp", Icon: MessageCircle, href: `https://wa.me/?text=${t}%20${u}`, color: "bg-[#25D366]" },
    { id: "facebook", label: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, color: "bg-[#1877F2]" },
    { id: "x", label: "X", Icon: Twitter, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`, color: "bg-black" },
    { id: "telegram", label: "Telegram", Icon: Send, href: `https://t.me/share/url?url=${u}&text=${t}`, color: "bg-[#229ED9]" },
    { id: "linkedin", label: "LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, color: "bg-[#0A66C2]" },
    { id: "email", label: "E-mail", Icon: Mail, href: `mailto:?subject=${t}&body=${u}`, color: "bg-zinc-700" },
  ];
};

export const ShareIcons = ({ title, url }) => (
  <div className="flex gap-1" data-testid="share-buttons">
    {shareLinks(title, url).map(({ id, label, Icon, href }) => (
      <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={label} data-testid={`share-top-${id}`} className="w-8 h-8 flex items-center justify-center bg-[#111827] text-white hover:bg-red-600 transition-colors"><Icon size={14} /></a>
    ))}
  </div>
);

export const ShareBar = ({ title, url }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = Object.assign(document.createElement("textarea"), { value: url, style: "position:fixed;opacity:0" });
        document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
      }
      setCopied(true);
      toast.success("Lien copié !");
      setTimeout(() => setCopied(false), 2500);
    } catch (error) {
      console.error("Copy error:", error);
      window.prompt("Copiez le lien de l'article :", url);
    }
  };
  return (
    <section data-testid="article-share-bar" className="mt-10 border-y-2 border-[#111827] py-5">
      <h3 className="font-heading font-extrabold uppercase text-sm tracking-wider mb-3">Partager cet article</h3>
      <div className="flex flex-wrap gap-2">
        {shareLinks(title, url).map(({ id, label, Icon, href, color }) => (
          <a key={id} href={href} target="_blank" rel="noreferrer" data-testid={`share-${id}`} className={`inline-flex items-center gap-2 ${color} text-white px-4 h-10 text-xs font-bold uppercase tracking-wider hover:opacity-85 transition-opacity`}>
            <Icon size={15} /> {label}
          </a>
        ))}
        <button type="button" onClick={copy} data-testid="share-copy-link" className="inline-flex items-center gap-2 border-2 border-[#111827] px-4 h-10 text-xs font-bold uppercase tracking-wider hover:bg-[#111827] hover:text-white transition-colors">
          {copied ? <Check size={15} /> : <Link2 size={15} />} {copied ? "Copié" : "Copier le lien"}
        </button>
      </div>
    </section>
  );
};
